import { isDefined } from '../ramda';
import { IAccordionItem } from './types';

export function isAccordionItemDefined(item?: IAccordionItem) {
  return isDefined(item?.title);
}
